import { render } from "./AddUserComponent.vue?vue&type=template&id=1dfd57f6&lang=html"
import script from "./AddUserComponent.vue?vue&type=script&lang=js"
export * from "./AddUserComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__